/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/engagement_data/chunk" endpoint.
 * Sends one part of the CSV as multipart/form-data.
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { PostEmailIpWarmingEngagementDataResultErrors } from "../emailIpWarmingAppGroupIdEngagementDataBeginUpload/types";
import { emailIpWarmingAppGroupIdEngagementDataChunkCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdEngagementDataChunkProps,
  EmailIpWarmingAppGroupIdEngagementDataChunkResult,
} from "./types";

export const postEmailIpWarmingAppGroupIdEngagementDataChunk = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdEngagementDataChunkCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingEngagementDataResultErrors>()(
    (
      props: PostEmailIpWarmingAppGroupIdEngagementDataChunkProps
    ): Promise<EmailIpWarmingAppGroupIdEngagementDataChunkResult> => {
      const body = new FormData();
      // Named, because the server checks the extension of every part rather than only the first.
      body.append("csv_file", props.csv_file, props.file_name);
      body.append("run_id", props.run_id);
      body.append("part_number", String(props.part_number));

      if (props.upload_id) {
        body.append("upload_id", props.upload_id);
      }

      if (props.last_part) {
        body.append("last_part", "true");
      }

      return fetch(
        `/email/ip_warming/${props.appGroupId}/engagement_data/chunk/${props.planId}`,
        "POST",
        {},
        { body },
        // The browser has to set the multipart boundary itself, so the JSON content type is suppressed.
        { setContentType: false, propagateFetchRequestError: false }
      );
    }
  )
);
